module.exports = require("@wordpress/blocks");